import React, { useState } from "react";
import BaseTooltip from "../../components/ui/BaseTooltip";
import { Avatar } from "@mui/material";
import JobsCompletedModal from "./Profile/components/JobsCompletedListingModal";
import useAuth from "../../hooks/useAuth";
import { fetchJobsCompletedCount } from "../../services/api/user";
import { useQuery } from "@tanstack/react-query";

import { formatPhoneNumber } from "../../utils/helpers";
const ProfileDetailsHeader = ({ user }) => {
  const { authRole } = useAuth();

  const [isJobsCompletedModalOpen, setIsJobsCompletedModalOpen] = useState(false);
  const openGooglMapLocation = () => {
    window.open(
      "https://maps.google.com?q=" +
        user?.personalAddress?.latitude +
        "," +
        user?.personalAddress?.longitude,
    );
  };
  const { data: jobsCompletedData, refetch: refetchJobs } = useQuery({
    queryKey: ["completedJobsCount", user?.id],
    queryFn: () => fetchJobsCompletedCount(user?.id),
    enabled: !!user?.id,
  });
  const addressLine1 = user?.isCompanyOwner
    ? user?.company?.address?.addressLine1
    : user?.personalAddress?.addressLine1;

  return (
    <>
      <div className="items-center grid grid-cols-12 lg:gap-32 ">
        <div className="lg:col-span-1 sm:col-span-3 col-span-12 md:block flex justify-center">
          <Avatar
            src={user?.picture?.url}
            className={`rounded-xl h-[100px] w-[100px]`}
            variant="square"
          ></Avatar>
        </div>
        <div className="lg:col-span-11 sm:col-span-9 col-span-12 ">
          <h6 className="font-normal capitalize sm:text-left text-center">
            {user?.firstName}{" "}
            {!(user?.role.role === "FREELANCER" && authRole === "CLIENT") && user?.lastName}{" "}
            <span className="text-base">ID: {user?.id}</span>
            {user?.isCompanyOwner && <i class="fa-solid fa-medal ml-4 text-amber-400"></i>}
          </h6>
          <div className="flex lg:flex-nowrap flex-wrap md:justify-start justify-center mt-3 gap-y-4">
            {addressLine1 && (
              <BaseTooltip
                position="top"
                interactive={true}
                content={<p className="text-white">{`${addressLine1}`}</p>}
              >
                <div
                  className="flex bg-[#E7FFF4] py-1 px-3 rounded-md mr-6 cursor-pointer"
                  onClick={openGooglMapLocation}
                >
                  <i className="fa-solid fa-location-dot text-[#147648] text-sm"></i>
                  <p className="text-[#147648] text-sm ml-2 truncate max-w-64 overflow-hidden whitespace-nowrap">
                    {addressLine1}
                  </p>
                </div>
              </BaseTooltip>
            )}
            {user?.role.role === "FREELANCER" && (
              <div className="flex bg-[#ECF4FF] py-1 px-3 rounded-md mr-6">
                <i className="fa-solid fa-clock-rotate-left text-[#3573CF] text-sm"></i>
                <p
                  onClick={() => setIsJobsCompletedModalOpen(true)}
                  className="text-[#3573CF] text-sm ml-2 cursor-pointer"
                >
                  Job History ({jobsCompletedData?.totalCount ?? 0})
                </p>
              </div>
            )}
            {user?.role.role === "FREELANCER" && (
              <div className="flex bg-[#F8FFED] py-1 px-3 rounded-md mr-6">
                <i className="fa-solid fa-suitcase text-[#74A525] text-sm"></i>
                <p className="text-[#74A525] text-sm ml-2">{user?.numberOfClients} Clients</p>
              </div>
            )}
            {(user?.role.role !== "FREELANCER" || user?.isCompanyOwner) && (
              <div className="flex bg-[#ECF4FF] py-1 px-3 rounded-md mr-6 ">
                <i className="fa-solid fa-phone text-[#3573CF] text-sm"></i>
                <p className="text-[#3573CF] text-sm ml-2">
                  {formatPhoneNumber(user?.phoneNumber) || "-"}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {isJobsCompletedModalOpen && (
        <JobsCompletedModal open={isJobsCompletedModalOpen} close={setIsJobsCompletedModalOpen} />
      )}
    </>
  );
};

export default ProfileDetailsHeader;
